/** @file Screen-pixel sizes of every handle and pick tolerance (constant at any zoom). */

/** Handle sizes and pick tolerances in screen pixels; the Wave-3 viewport draws with the same numbers. */
export const HANDLE_PX = {
  /** Bone body pick tolerance (distance to the bone segment). */
  bone: 6,
  /** Radius of the bone joint and tip discs. */
  joint: 7,
  /** Joint snap radius (JOINT_SNAP, R16-01): a joint this close beats any tip or body hit. */
  jointSnap: 3,
  /** Mesh vertex and generic point pick radius. */
  point: 6,
  /** Length of the translate and scale axes. */
  axis: 64,
  /** Radius of the free-move, uniform-scale and axis-scale discs. */
  disc: 7,
  /** Half-width of the translate axis hit band. */
  band: 6,
  /** Radius of the rotate ring. */
  ring: 56,
  /** Half-width of the rotate ring hit band. */
  ringBand: 6,
  /** Dopesheet key hit tolerance (horizontal distance to the key centre). */
  key: 5,
} as const;
